export const getTimesheetsRoute = '/timesheets';
export const getStaffTimesheetsRoute = '/staff-timesheets';
export { crewTimesheetIndexRoute, getCrewTimesheetRoute } from '../../Timesheet/helpers/routes';
